import { pathOr } from 'ramda';

import { Box, HStack, Text, VStack } from '@frontend/components';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';

const PartMatchCell = ({ quoteItemResult }) => {
  return (
    <Box alignContent="left">
      <Text fontFamily="data" fontSize="sm">
        From{' '}
        <Text as="span" fontSize="sm" fontWeight="heavy">{` Quote #`}</Text>
        <HighlightOrDisplay
          field="quoteNumber"
          result={quoteItemResult}
          textProps={{ fontWeight: 'heavy' }}
          useDataFont
        />
      </Text>
      <PartCell
        href={`/quotes/edit/${quoteItemResult.data.quoteNumber}?quote_item=${quoteItemResult.data.id}`}
        partResult={quoteItemResult}
        filename={pathOr(null, ['data', 'filenames', 0], quoteItemResult)}
        primaryFileUuid={pathOr(
          null,
          ['data', 'primaryFileUuid'],
          quoteItemResult,
        )}
      />
      <HStack paddingTop={1}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Process</LabelText>
          <LabelText>Material</LabelText>
          <LabelText>Finish</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay field="process" result={quoteItemResult} />
          <HighlightOrDisplay field="material" result={quoteItemResult} />
          <HighlightOrDisplay field="finishes" result={quoteItemResult} />
        </VStack>
      </HStack>
    </Box>
  );
};

export default PartMatchCell;
